import React, { PropTypes, Component } from 'react';
import classNames from 'classnames'
import BaseDetails from './BaseDetails.jsx';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import { alertsDataDirection as direction } from 'pluton-core/lib/services/core/alerts/alerts.constant';
import { getCurrentPathname } from 'pluton-core/lib/utils/rn.helper';
import {
    isImportantAlert,
    findDateToScroll,
    findAlertToScroll
} from 'pluton-core/lib/services/core/alerts/alerts.helper';


class Details extends BaseDetails {

    componentDidUpdate(prevProps, prevState) {
        if (this._scrollToMiddle(prevProps, prevState)) {
            return;
        }

        if (this._scrollToAlert(prevProps, prevState)) {
            return;
        }

        this._scrollToDateBeforeUp(prevProps, prevState);
    }

    _scrollToAlert = (prevProps, prevState) => {
        if (!this.props.alertReducer || !this.props.alertReducer.alertToJump.alert) {
            return false;
        }

        const {
            details,
            alertReducer: {
                alertToJump:{
                    group,
                    alert,
                    index,
                }
            },
            handleClearAlertToJump
        } = this.props;
        const groupedItem = findAlertToScroll(group, alert, index, details);
        if (!groupedItem) {
            return false;
        }

        const itemToJumpRef = this.refs[groupedItem.index];
        itemToJumpRef.scrollIntoView();
        handleClearAlertToJump();

        return true;
    };

    _scrollToMiddle = (prevProps, prevState) => {
        const {
            date,
            details : {
                alertsDataDirection
            },
        } = this.props;

        if (prevProps.details.alertsDataDirection !== direction.UP_DOWN
            && alertsDataDirection === direction.UP_DOWN
            && this.refs.scroll
            && getCurrentPathname(this.props) === routes.alert()) {

            const dateGroupToScroll = findDateToScroll(date, this.props.details);
            if (!dateGroupToScroll) {
                return false;
            }

            const groupToJumpRef = this.refs[dateGroupToScroll.dateGroup];
            groupToJumpRef.scrollIntoView();
            return true;
        }

        return false;
    };

    _scrollToDateBeforeUp = (prevProps, prevState) => {
        /*
         * if do up then should leave focus on current item - not scroll up
         * */
        const {
            details : {
                dateGroupedItems,
                alertsDataDirection
            },
        } = this.props;

        if (alertsDataDirection !== direction.UP) {
            return false;
        }

        if (!dateGroupedItems || !dateGroupedItems.length) {
            return false;
        }

        const prevDateGroupedItems = prevProps.details.dateGroupedItems;
        if (!prevDateGroupedItems || !prevDateGroupedItems.length) {
            return false;
        }

        const groupedItem = dateGroupedItems[0].groupedItems[0];
        const prevGroupedItem = prevDateGroupedItems[0].groupedItems[0];

        if (groupedItem.index !== prevGroupedItem.index) {
            const detailsRefs = this.refs[prevDateGroupedItems[0].dateGroup];
            detailsRefs.scrollIntoView();
            return true;
        }
    };

    renderItems = (groupedItem) => {
        if (groupedItem.items && groupedItem.items.length) {
            return groupedItem.items.map((item, itemIndex) => {
                return (
                    <div key={itemIndex} className="alert-about">
                        <div className="alert-about__message">{item.message}</div>
                        <div className="alert-about__date">{item.date}</div>
                    </div>
                );
            });
        }

        return null;
    };

    renderSummary = (groupedItem) => {
        if (!groupedItem.summary) {
            return null;
        }

        return (
            <div className="alert-summary">
                {groupedItem.summary}
            </div>
        );
    };

    renderBody = (dateGroupedItem) => {
        const {
            handleAlertsToggle,
            alertsToggled,
        } = this.props;

        const { groupedItems } = dateGroupedItem;
        if (!groupedItems || !groupedItems.length) {
            return null;
        }

        return dateGroupedItem.groupedItems.map((groupedItem, groupedItemIndex) => {
            const isOpen = !!~alertsToggled.indexOf(groupedItem.index);
            const alertClassName = isOpen ? 'alert alert--open' : 'alert';
            const classNamesObj = classNames({
                [alertClassName]: true,
                'alert--important': isImportantAlert(groupedItem.severity)
            });

            return (
                <div ref={`${groupedItem.index}`}
                     key={groupedItemIndex}
                     onClick={handleAlertsToggle.bind(this, groupedItem)}
                     className={classNamesObj}>

                    <div className="alert__header">
                        {this.renderIcon(groupedItem)}
                        <div className="alert__title">
                            <div className="alert__title-text">
                                {groupedItem.name}
                            </div>
                            <div className="alert__title-time">
                                {groupedItem.time}
                            </div>
                        </div>
                    </div>

                    <div className="alert__content">
                        {isOpen && this.renderItems(groupedItem)}
                        {isOpen && this.renderSummary(groupedItem)}
                    </div>
                </div>
            );
        });
    };
}

Details.propTypes = {
    alertModel: PropTypes.func,
    date: PropTypes.object,

    details: PropTypes.object,
    handleGetPrev: PropTypes.func,
    handleGetNext: PropTypes.func,

    showImportant: PropTypes.bool,

    alertsToggled: PropTypes.array,
    handleAlertsToggle: PropTypes.func,

    alertReducer: PropTypes.object,
    handleClearAlertToJump: PropTypes.func,

    handleOnScroll: PropTypes.func
};

export default Details;



// WEBPACK FOOTER //
// ./app/components/custom/details/Details.jsx